import React from 'react';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';

const SortableHeader = ({ 
  title, 
  sortField, 
  currentSortField, 
  currentSortOrder, 
  onSort 
}) => {
  const isActive = currentSortField === sortField;
  
  const handleClick = () => {
    let newOrder = 'asc';
    if (isActive && currentSortOrder === 'asc') {
      newOrder = 'desc';
    } else if (isActive && currentSortOrder === 'desc') {
      newOrder = 'asc';
    }
    onSort(sortField, newOrder);
  };

  const getSortIcon = () => {
    if (!isActive) {
      return (
        <div className="flex flex-col ml-2 opacity-30">
          <CaretUpOutlined className="text-xs -mb-1" />
          <CaretDownOutlined className="text-xs" />
        </div>
      );
    }
    
    if (currentSortOrder === 'asc') {
      return <CaretUpOutlined className="ml-2 text-blue-600" />;
    } else {
      return <CaretDownOutlined className="ml-2 text-blue-600" />;
    }
  };

  return (
    <div 
      className="flex items-center cursor-pointer hover:text-blue-600 transition-colors"
      onClick={handleClick}
    >
      <span>{title}</span>
      {getSortIcon()}
    </div>
  );
};

export default SortableHeader;
